<template>
    <div class="org-select-tree-list">
        <v-spinner
            v-if="loading"
            status="default"
            class="org-select-loading"
        />
        <v-tree
            v-else
            ref="tree"
            :maps="maps"
            :options="currentOptions"
            :selected="currentSelected"
            :single="single"
            :folder-can-select="false"
            :only-folder-id="true"
            :user-indent="25"
            @sync="syncTree"
            @change="selectedChange"
        >
            <!-- <template slot-scope="props" slot="label">
                <org-item :option="props.options"></org-item>
            </template> -->
            <template
                slot="item"
                slot-scope="props"
            >
                <a
                    class="v-tree__title"
                    :class="{
                        //'is-selected': props.selected,
                        'is-loading': props.loading,
                        'is-fselected': folderSelectedMap[folderSelectIdKey + props.options.id],
                        'is-folder': props.isFolder,
                        'has-selected': props.options.hasSelected
                    }"
                    @click="!props.options.hasSelected && handleItemClick(props)"
                >
                    <span
                        class="v-tree__button v-tree__button--before"
                        :style="'width:' + props.indent + 'px;'"
                    /><span
                        v-if="props.isFolder"
                        class="v-tree__button v-tree__button--switch"
                        :class="[props.expand ? '' : 'is-close']"
                        @click.stop="handleSwitchClick(props)"
                    />
                    <org-item :option="props.options" />
                </a>
            </template>
        </v-tree>
    </div>
</template>

<script>
import OrgItem from '@/components/org-item';
import { formatListData } from './utils/format';

/**
 * 该组件，在部门下直接选择的数据和通过搜索得到的数据输出的数据格式不同，导致使用的时候因为用法问题产生了一定的问题，将会在分组沉淀需求上线后修复这个问题，并提供一个数据输出文档
 * 现在临时在业务组件中修复这个问题 @feiyugao
 */

export default {
  components: {
    OrgItem,
  },
  props: {
    hisSelected: {
      type: Array,
      default() {
        return [];
      },
    },

    selected: {
      type: Array,
      default() {
        return [];
      },
    },

    single: {
      type: Boolean,
      default: false,
    },

    departCanSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      maps: {
        value: 'id',
        hasChildren: 'isFolder',
      },

      currentOptions: [],
      currentSelected: [],

      folderSelectedMap: {},
      folderSelectIdKey: 'f_',
    };
  },
  watch: {
    currentInit(val) {
      if (val) {
        this.loading = false;
        this.fetchInitData();
        // 重复的180925注释观察 @feiyugao
        // this.getTreeData();
        if (this.openType === 'clean') {
          this.currentSelected = [];
        }
        // val = false;
      }
    },

    selected(nextValue) {
      this.setCurrentSelectedVal(nextValue);
    },

    currentSelected(val) {
      if (this.departCanSelect) {
        this.folderSelectedMap = {};
        val.forEach((v) => {
          if (v.isFolder) {
            this.folderSelectedMap[v.id] = true;
          }
        });
      }
    },
  },

  created() {
    this.setCurrentSelectedVal(this.selected);
  },

  mounted() {
    this.fetchInitData();
  },
  methods: {
    fetchInitData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.getTreeData()
        .then((res) => {
          this.fetchInitDataError = false;
          this.loading = false;
          this.currentOptions = formatListData(res.list, this.hisSelected) || [];
          if (this.currentOptions.length === 1) {
            this.$nextTick(() => {
              this.$refs.tree.expand(0);
            });
          }
        })
        .catch(() => {
          this.fetchInitDataError = true;
          this.loading = false;
        });
    },

    getScrollWidth() {
      const oDiv = document.createElement('DIV');
      oDiv.style.cssText = 'position:absolute; visibility:hidden; width:30px;';
      const noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = 'scroll';
      const scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      return noScroll - scroll;
    },

    selectedChange(selected) {
      this.$emit('change', this.transData('selectToOrigin', selected));
    },

    removeSelected(e) {
      const id = e.currentTarget.getAttribute('id');
      this.$refs.tree.removeSelected(id);
    },
    syncTree($vm) {
      const orgId = $vm.options.id;
      this.getTreeData(orgId)
        .then((res) => {
          const records = formatListData(res.list, this.hisSelected) || [{}];
          $vm.addChild(records);
          $vm.hideLoading();
          $vm.setSynced();
        })
        .catch(() => {
          $vm.hideLoading();
          $vm.expand = false;
        });
    },
    getTreeData(orgId) {
      const defer = this.$ajax.get('/mng/org/getOrgAndUserTreeNodes', {
        hold: !orgId,
        params: {
          id: orgId || 0,
        },
      });
      defer.catch((res) => {
        this.$message.error(res.message || '获取数据失败');
      });

      return defer;
    },

    handleItemClick(vm) {
      if (!this.departCanSelect) {
        vm.onItemClicked();
      } else if (vm.isFolder) {
        const vmInfo = {
          id: `${this.folderSelectIdKey}${vm.options.id}`,
          originId: vm.options.id,
          name: vm.options.name,
          isFolder: true,
        };

        const selected = !this.folderSelectedMap[vmInfo.id];

        if (selected) {
          this.$refs.tree.addSelected([vmInfo]);
        } else {
          this.$refs.tree.removeSelected(vmInfo.id);
        }

        // this.$refs.tree.emitChangeEvent();
      } else {
        vm.changeCheckState(undefined, true);
      }
    },

    handleSwitchClick(vm) {
      vm.onItemClicked();
    },

    transData(type, arr) {
      return arr.map((item) => {
        const { id, originId, isFolder } = item || {};
        const mapItem = { ...item };

        if (isFolder) {
          if (type === 'selectToOrigin' && originId) {
            mapItem.id = originId;
          } else if (type === 'originToSelect') {
            mapItem.id = `${this.folderSelectIdKey}${id}`;
            mapItem.originId = id;
          }
        }

        return mapItem;
      });
    },

    setCurrentSelectedVal(arr) {
      this.currentSelected = this.transData('originToSelect', arr);
    },
  },
};
</script>
